import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as markupBundleActions from './../../../../actions/markupBundleAction';
import MarkupBundles from './MarkupBundles';

const mapStateToProps = state => {
    return {
        markupBundleState: state.markupBundleReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListMarkupBundles: (filters) => dispatch(markupBundleActions.getListMarkupBundles(filters)),
        deleteMarkupBundleDetail: (markupBundle, filters) => dispatch(markupBundleActions.deleteMarkupBundleDetail(markupBundle, filters))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(MarkupBundles));
